module.exports = new __parcel__URL__("neon_gold_storage_level_10.60ed378b.png").toString();